import type { ReactNode } from "react";
import { SettingsSectionBase } from "@src/components/settings/SettingsSection";

interface SettingsSectionProps {
  /** Section title displayed above the items */
  title: string;
  /** List items to render inside the section */
  children: ReactNode;
}

export function SettingsSection({ title, children }: SettingsSectionProps) {
  return <SettingsSectionBase title={title}>{children}</SettingsSectionBase>;
}
